import { DrawerContainer } from "./container";

export const Drawer = (props: { drawerWidth: number }) => {
  const { drawerWidth } = props;
  return <DrawerContainer drawerWidth={drawerWidth} />;
};
